import { loadView, loadComponent } from '@/helpers/asyncLoaders'

import store from '@/store/store'

import {
  VUEX_ROUTING_ENTER_DASHBOARD
} from '@/store/constants/routing/routingDashboard'

export default {
  path: '/confirm-email/:messages',
  // name: 'confirmEmail',
  component: loadView('app/Headless.vue'),
  children: [
    // {
    //   path: '',
    //   name: 'confirmEmail--default',
    //   redirect: { name: 'confirmEmail--its' }
    // },
    {
      path: '',
      name: 'confirmEmail--its',
      component: loadComponent('Dashboard/Dashboard_Its.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch(VUEX_ROUTING_ENTER_DASHBOARD, { to: to, from: from }).then(() => next())
      }
    }
  ],
  meta: {
    label: 'Dashboard'
  }
}
